import { v4 as uuidv4 } from "uuid";
import { makeAutoObservable, reaction } from "mobx";
import { storage } from "./FirestoreConfig";
import { MessageStatus } from "../../Resources/Constants";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { startOfWeek } from "../utils/dateUtils";
import NetworkManager from "../Classes/NetworkManager";

class ChatMessage {
  isDownloadingMedia = false;
  isPlaying = false;
  currentTime = 0.0;

  constructor(
    id = uuidv4(),
    timestamp = Date(),
    text = "",
    type = null,
    isFromCoach = false,
    replyTo = null,
    attachment = null,
    totalTime = 0.0,
    serieId = null,
    workoutId = null,
    blockId = null,
    client = null,
    status = MessageStatus.SENDING,
    originalAttachmentURL = null
  ) {
    this.id = id;
    this.timestamp = timestamp;
    this.text = text;
    this.type = type;
    this.isFromCoach = isFromCoach;
    this.replyTo = replyTo;
    this.attachment = attachment;
    this.totalTime = totalTime;
    this.serieId = serieId;
    this.workoutId = workoutId;
    this.blockId = blockId;
    this.client = client;
    this.status = status;
    this.originalAttachmentURL = originalAttachmentURL;
    if (client) {
      client.messageIds.add(id.toLowerCase());
    }
    makeAutoObservable(this);
  }
  setProperty(propertyName, value) {
    if (propertyName in this) {
      this[propertyName] = value;
    } else {
      console.warn(`Property "${propertyName}" does not exist on ChatMessage.`);
    }
  }
  // localURL(thumbnail = false) {
  //   let folder, fileName;

  //   if (thumbnail && this.type === "video") {
  //     // Return the local path for the video thumbnail.
  //     if (!this.serieId) return null;
  //     folder = "video_thumbnails/";
  //     fileName = this.serieId.toString() + ".jpg";
  //   } else {
  //     if (this.type === "video") {
  //       if (!this.serieId) return null;
  //       folder = "video_messages/";
  //       fileName = this.serieId.toString() + ".mp4";
  //     } else if (this.type === "image") {
  //       if (!this.id) return null;
  //       folder = "image_messages/";
  //       fileName = this.id.toString() + ".jpg";
  //     } else if (this.type === "audio") {
  //       if (!this.id) return null;
  //       folder = "audio_messages/";
  //       fileName = this.id.toString() + ".m4a";
  //     } else {
  //       return null;
  //     }
  //   }

  //   const localPath = FileSystem.documentDirectory + folder + fileName;
  //   return localPath;
  // }
  // async isDownloaded(thumbnail = false) {
  //   // Use the local thumbnail URL if thumbnail is true, otherwise use the unified local URL.
  //   const url = this.localURL(thumbnail);
  //   if (!url) return false;

  //   try {
  //     const fileInfo = await FileSystem.getInfoAsync(url);
  //     return fileInfo.exists;
  //   } catch (error) {
  //     console.error(
  //       `Error checking ${thumbnail ? "thumbnail" : this.type} file:`,
  //       error
  //     );
  //     return false;
  //   }
  // }

  async getAttachmentURL(thumbnail = false) {
    let folder;
    let fileName;

    if (thumbnail) {
      if (this.type === "video") {
        folder = "video_thumbnails";
        fileName = `${this.serieId}.jpg`;
      } else {
        console.error("Thumbnails are only available for video messages.");
        return null;
      }
    } else {
      if (this.status === MessageStatus.SENDING) {
        console.log("Message is not yet uploaded");
        return null;
      }

      switch (this.type) {
        case "image":
          folder = "image_messages";
          fileName = `${this.id}.jpg`;
          break;
        case "audio":
          folder = "audio_messages";
          fileName = `${this.id}.m4a`;
          break;
        case "video":
          folder = "video_messages";
          fileName = `${this.serieId}.mp4`;
          break;
        default:
          console.error("Unknown message type:", this.type);
          return null;
      }
    }

    const storagePath = `coaches/${this.client.coach.id}/chats/${this.client.id}/${folder}/${fileName}`;
    // console.log("storagePath", storagePath);

    try {
      const storage = getStorage(undefined, "gs://efort-app-storage-eu"); // This will use default app and region
      const storageRef = ref(storage, storagePath);
      const url = await getDownloadURL(storageRef);
      return url;
    } catch (error) {
      console.error("Error retrieving download URL:", error);
      return null;
    }
  }

  get getSerie() {
    const internalBlock = this.client.blocks.find(
      (block) => block.id === this.blockId
    );
    if (!internalBlock) {
      return null;
    }
    const internalWorkout = internalBlock.workouts.find(
      (workout) => workout.id === this.workoutId
    );
    if (!internalWorkout) {
      return null;
    }

    return (
      internalWorkout.allWorkoutSeries.find((serie) => {
        const serieIdStr = serie.id;
        return serieIdStr === this.serieId;
      }) || null
    );
  }

  uploadToCloud() {
    const networkManager = NetworkManager.getInstance();
    const timestamp = networkManager.getNetworkTime();
    return {
      id: this.id.toString(),
      is_from_coach: this.isFromCoach,
      ...(this.replyTo ? { reply_to: this.replyTo } : {}),
      text: this.text ?? "",
      timestamp: timestamp ?? this.timestamp,
      type: this.type,
      // ...(this.attachment ? { attachment: this.attachment } : {}),
      ...(this.serieId ? { serie_id: this.serieId.toString() } : {}),
      ...(this.workoutId ? { workout_id: this.workoutId.toString() } : {}),
      ...(this.blockId ? { block_id: this.blockId.toString() } : {}),
      ...(this.type === "audio" || this.type === "video"
        ? { total_time: this.totalTime }
        : {}),
    };
  }

  // get videoStoragePath() {
  //   if (!this.serieId) return null;
  //   // These values should match what you used when uploading the video.
  //   const coachId = this.client.coach.id; // or however you get the coach id
  //   const chatId = this.client.id; // or however you get the chat id
  //   if (!coachId || !chatId) return null;

  //   return `coaches/${coachId}/chats/${chatId}/video_messages/${this.serieId}.mp4`;
  // }

  // async getVideoDownloadURL() {
  //   const path = this.videoStoragePath;
  //   if (!path) return null;
  //   try {
  //     const videoRef = ref(storage, path);
  //     const url = await getDownloadURL(videoRef);
  //     return url;
  //   } catch (error) {
  //     console.error("Error getting video download URL:", error);
  //     return null;
  //   }
  // }

  isSameDay(date1, date2) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }

  isYesterday(date) {
    const now = new Date();
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    return this.isSameDay(date, yesterday);
  }

  daysBetween(date1, date2) {
    const msPerDay = 1000 * 3600 * 24;
    return Math.floor((date2 - date1) / msPerDay);
  }

  timeAgo(t, language) {
    if (!this.timestamp) return "";

    const now = new Date();

    // If the timestamp is in the future, return "now"
    if (this.timestamp > now) {
      return t("now-string");
    }

    // Calculate the interval in seconds.
    const interval = (now - this.timestamp) / 1000;

    // Decide which locale to use
    const locale = language === "es" ? "es-ES" : "en-US";

    // If less than one hour, return the time in HH:mm (24-hour format)
    if (interval < 3600) {
      return this.timestamp.toLocaleTimeString(locale, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    }
    // If less than 24 hours, return the number of hours (e.g., "5h")
    else if (interval < 24 * 3600) {
      const hours = Math.floor(interval / 3600);
      return `${hours}h`;
    }
    // If the timestamp is from yesterday, return "yesterday"
    else if (this.isYesterday(this.timestamp)) {
      return t("yesterday-string");
    }

    // Compute the start of this week (you can pass options if your helper supports e.g. weekStartsOn)
    const weekStart = startOfWeek();

    // If it's on or after the start of this week, show the weekday name
    if (this.timestamp >= weekStart) {
      const rawDay = this.timestamp.toLocaleDateString(locale, {
        weekday: "long",
      });
      return rawDay.charAt(0).toUpperCase() + rawDay.slice(1);
    }
    // Otherwise, return the date in dd/MM/yy format
    else {
      const dd = String(this.timestamp.getDate()).padStart(2, "0");
      const mm = String(this.timestamp.getMonth() + 1).padStart(2, "0");
      const yy = String(this.timestamp.getFullYear()).slice(-2);
      return `${dd}/${mm}/${yy}`;
    }
  }
}

export default ChatMessage;
